import { memo } from 'react';
import { css } from '@emotion/react';
import { isWeaveUser } from '@frontend/auth-helpers';
import { useDevToolsStore } from '@frontend/devtools';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { CALENDAR_Z_INDICES } from '../constants';
import { useCalendarGridStore } from '../store/calendar-grid.store';

const DebugControlsComponent = () => {
  const shouldShowControls = useDevToolsStore((state) => state.options.isDebugModeOn);
  const { debug, groupIds, groupsById, columnsById, eventsById, toggleDebug } = useCalendarGridStore([
    'debug',
    'groupIds',
    'groupsById',
    'columnsById',
    'eventsById',
    'toggleDebug',
  ]);
  if (!isWeaveUser() || !shouldShowControls) {
    return null;
  }

  const handleInfoClick = () => {
    console.log('Calendar Grid Debug Info:', {
      groupIds,
      groupInfo: groupIds.map((groupId) => {
        return {
          ...groupsById[groupId],
          columns: groupsById[groupId]?.columnIds.map((columnId) => {
            return {
              ...columnsById[columnId],
              events: columnsById[columnId]?.eventIds.map((eventId) => eventsById[eventId]),
            };
          }),
        };
      }),
    });
  };

  return (
    <div data-debug-controls css={containerStyle}>
      <Button size='tiny' variant='secondary' iconName='info' onClick={handleInfoClick} />
      <Button
        size='tiny'
        variant='secondary'
        iconName='action'
        onClick={toggleDebug}
        css={{ svg: { color: debug ? theme.colors.critical50 : theme.colors.neutral50 } }}
      />
    </div>
  );
};

export const DebugControls = memo(DebugControlsComponent);

const containerStyle = css({
  gridColumn: '-2 / -1',
  gridRow: 3,
  zIndex: CALENDAR_Z_INDICES.topCornerCell,
  position: 'sticky',
  top: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',

  opacity: 0.5,
  '&:hover': {
    opacity: 1,
  },
});
